module.exports = __webpack_public_path__ + "static/media/eco-ecology-leaf-6-svgrepo-com.1f9b859b.svg";